import {
	defaultTqcInspectResultDtlDto,
	TqcInspectResultDtlDto,
} from "src/dtos/tqcInspectResult/tqcInspectResultDto";
import {
	defaultWmsTransportDetailDto,
	WmsTransportDetailDto,
} from "src/dtos/wmsTransport/wmsTransportDto";

export interface TQC1060_R01HeaderDto extends WmsTransportDetailDto {
	inoutClass: string;
	inoutClassNm: string;
	customCd: string;
	customNm: string;
	itemGroup: string;
	lotNo: string;
	inspectNo: string;
	inspectType: string;
	inspectDt: string | undefined;
	inspectorEmp: string;
	inspectorEmpNm: string;
	approvorEmpno: string;
	approvorEmpNm: string;
}

export const defaultTQC1060_R01HeaderDto: TQC1060_R01HeaderDto = {
	...defaultWmsTransportDetailDto,
	inoutClass: "",
	inoutClassNm: "",
	customCd: "",
	customNm: "",
	itemGroup: "",
	lotNo: "",
	inspectNo: "",
	inspectType: "",
	inspectDt: undefined,
	inspectorEmp: "",
	inspectorEmpNm: "",
	approvorEmpno: "",
	approvorEmpNm: "",
	inserted: false,
	isModified: false,
};

export interface TQC1060_R01DetailDto extends TqcInspectResultDtlDto {
	inspItemGroup: string;
	inspType: string;
	inspItemNm: string;
	specText: string;
	valueType: string;
	valueTypeNm: string;
	inspUnit: string;
	valueIndex: number;
	isModified: boolean;
	inserted: boolean;
}

export const defaultTQC1060_R01DetailDto: TQC1060_R01DetailDto = {
	...defaultTqcInspectResultDtlDto,
	inspItemGroup: "",
	inspType: "",
	inspItemNm: "",
	specText: "",
	valueType: "",
	valueTypeNm: "",
	inspUnit: "",
	valueIndex: 0,
	isModified: false,
	inserted: false,
};

export interface TQC1060_R01Dto {
	header: TQC1060_R01HeaderDto;
	detailList: TQC1060_R01DetailDto[];
}

export const TQC1060_R01_COMP_CD = "1000";
export const TQC1060_R01_VALUE_FIELDS = [
	"inspectValue1_1",
	"inspectValue1_2",
	"inspectValue1_3",
	"inspectValue1_4",
	"inspectValue1_5",
] as const;
